module.exports = __webpack_public_path__ + "static/media/ft-logo.fbfc946d.png";